import dom from "../../dist/jsx-render/dom";

export class Progressbar {
    public static render(current: number, total: number, info?: string): HTMLElement {
        if (total === 0) return null;

        let percentage = this.calculatePercentage(current, total);

        let element = <div class="progress-container" style="height: 1px;"></div> as HTMLElement;
        let infoText = <label id="info-text">{info ? `${Resources.Common[info]}...` : ''}</label>
        let progress = <div class="progress" style="height: 1px;"></div> as HTMLElement;
        let progressBar = <div class="progress-bar" role="progressbar" aria-valuenow={percentage} aria-valuemin="0" aria-valuemax="100">{current}/{total}</div> as HTMLElement;

        progressBar.style.width = `${percentage}%`;
        progress.appendChild(progressBar);
        element.appendChild(infoText);
        element.appendChild(progress);

        return element;
    }

    public static update(element: HTMLElement, current: number, total: number, info?: string): HTMLElement {
        if (total === 0) return null;

        let infoText = element.querySelector("#info-text") as HTMLLabelElement;
        infoText.textContent = info ? `${Resources.Common[info]}...` : '';

        let percentage = this.calculatePercentage(current, total);
        let progressBar = element.querySelector(".progress-bar") as HTMLElement;
        progressBar.style.width = `${percentage}%`;
        progressBar.textContent = `${current}/${total}`;

        return element;
    }

    private static calculatePercentage = (current: number, total: number): number => {
        if (total === 0) return 0;
        if (current >= total) return 100;

        return Math.round(current / total * 100);
    }

}